module.exports = __webpack_public_path__ + "Roboto-Bold-webfont.ecdd509cadbf1ea78b8d.eot";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Bold-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold-webfont.eot
// module chunks = 2